import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
/**
 * Use this to show a title area on widgets. You can set a title on the left side
 * and any arbitrary content on the right side - typically you would use a {@component FilterPanel} there.
 * The content that appears on the right side go as children of this component.
 * @export
 *
 * @example
 *
 * ```
 * <TitleBar title='My Test Widget'>
 *      <div>Active</div>
 * </TitleBar>
 * ```
 *
 * @category Layout
 */
const TitleBar = (props) => {
    return _jsxs("div", { className: classNames('uxp-widget-title-bar', 'uxpcore_titlebar', 'uxp-drag-handler', 'uxpcore_titlebar--draggable', props.className), children: [_jsxs("div", { className: 'title-section uxpcore_titlebar__title-section', children: [_jsx("span", { style: { backgroundImage: props.icon ? `url(${props.icon})` : '' }, className: classNames('title-icon', 'uxpcore_titlebar__icon', {
                            'visible': !!props.icon,
                            'uxpcore_titlebar__icon--visible': !!props.icon
                        }) }), _jsx("span", { className: 'txt uxpcore_titlebar__text', children: props.title })] }), _jsx("div", { className: 'action-section uxpcore_titlebar__action-section', children: props.children })] });
};
export default TitleBar;
